// ABOUTME: The dashboard coaching ad for FreeBusy booking: FreeBusy opens from its button id
// ABOUTME: The button is disabled while FreeBusy cannot schedule
import { observer } from 'mobx-react';
import * as React from 'react';
import FreebusyStore from '../../../FreebusyStore';
import AdDisplayView from './AdDisplayView';
import { FREEBUSY_BUTTON_ID } from './Types';

interface Props {
  freebusyStore: FreebusyStore;
}

const AdDisplayContent: React.FC<Props> = ({ freebusyStore }) => (
  <AdDisplayView
    buttonId={FREEBUSY_BUTTON_ID}
    disabled={freebusyStore.schedulingDisabled}
    onClick={() => {}}
  />
);

export default observer(AdDisplayContent);
